(function() {

  'use strict';
  if ($('#filtro').val() != null && $('#filtro').val() != '') {
    $([document.documentElement, document.body]).animate({
      scrollTop: $('#filtriCitta').offset().top
    },800);
  }
  

}());
